// ══════════ SHARED UTILITIES ══════════

// Units treated as 1/1000 of the base unit (kg or L)
export const SMALL_UNITS = ['g', 'gm', 'gram', 'grams', 'ml'];

// Convert a quantity to kg (or L) based on its unit — single source of truth
export function convertToKg(qty, unit) {
  const q = parseFloat(qty) || 0;
  const u = (unit || 'kg').toLowerCase().trim();
  if (u === 'mg') return q / 1000000;
  return SMALL_UNITS.includes(u) ? q / 1000 : q;
}

// Total RM weight in kg for a list of ingredients
export function totalRMKg(ingredients) {
  return (ingredients || []).reduce((s, i) => s + convertToKg(i.quantity, i.unit), 0);
}

// Development cost = trial + linked additional + category dev — single source of truth
export function devCost(p) {
  return (p?.trial_cost || 0) + (p?.linked_additional_cost || 0) + (p?.category_dev_cost || 0);
}

// Format as AED currency string
export function fmtAED(v, decimals = 0) {
  return 'AED ' + (parseFloat(v) || 0).toLocaleString('en-AE', { maximumFractionDigits: decimals, minimumFractionDigits: 0 });
}
